import _classCallCheck from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { isArray } from 'vega-util';
import { some } from '../../util';
import { Split } from '../split';
export var ScaleComponent = /*#__PURE__*/function (_Split) {
  _inherits(ScaleComponent, _Split);

  function ScaleComponent(name, typeWithExplicit) {
    var _this;

    _classCallCheck(this, ScaleComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScaleComponent).call(this, {}, // no initial explicit property
    {
      name: name
    } // name as initial implicit property
    ));
    _this.merged = false;

    _this.setWithExplicit('type', typeWithExplicit);

    return _this;
  }
  /**
   * Whether the scale definitely includes zero in the domain
   */


  _createClass(ScaleComponent, [{
    key: "domainDefinitelyIncludesZero",
    value: function domainDefinitelyIncludesZero() {
      if (this.get('zero') !== false) {
        return true;
      }

      return some(this.get('domains'), function (d) {
        return isArray(d) && d.length === 2 && d[0] <= 0 && d[1] >= 0;
      });
    }
  }]);

  return ScaleComponent;
}(Split);